import { useEffect } from "react";
import { useParams } from "react-router";

import { useQuery, useQueryClient } from "@tanstack/react-query";

import { clientsApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { ClientByIdParams } from "@/router/ClientRoutes";

export function useClient() {
  const { id } = useParams<ClientByIdParams>();
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.Client, id],
    queryFn: () => {
      if (!id) {
        throw new Error("Client ID is required");
      }
      return clientsApi.getClientById({ clientId: id });
    },
    enabled: !!id,
    meta: { loadingScope: "pageContent" },
    gcTime: 0,
    staleTime: 0,
  });

  useEffect(() => {
    if (data) {
      void queryClient.invalidateQueries({ queryKey: [QueryKey.LastOpenedClients] });
    }
  }, [data, queryClient]);

  return {
    client: data,
    isLoading,
  };
}
